import {SeatConfig} from "../API";

export function isSeatBookable(seatId: string | null, seatIdToSeatConfig: Map<string, SeatConfig>) {
    const seatConfig = seatIdToSeatConfig?.get(seatId!);
    if (!seatConfig) {
        return null;
    }
    return seatConfig?.isBookable ?? false;
}